
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/charts/pie-chart-pro",
      function () {
        return require("private-next-pages/x/api/charts/pie-chart-pro.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/charts/pie-chart-pro"])
      });
    }
  